module.exports = __webpack_public_path__ + "img/IconBlack.29fd8f17.jpg";